module.exports = __webpack_public_path__ + "media/images/error1-db093ba043cccd5dd5196d92cf584801.svg";